export default function Maillage() {
  const links = [
    {
      label: "Motorisation de volet roulant Somfy",
      href: "/motorisation-somfy",
      desc: "Motorisation complète de volets roulants avec Somfy à Strasbourg",
    },
    {
      label: "Moteur Somfy de volet roulant",
      href: "/moteur-somfy",
      desc: "Remplacement et dépannage de moteurs Somfy dans le Bas-Rhin",
    },
    {
      label: "Dépannage urgence volet roulant",
      href: "/depannage-urgence",
      desc: "Intervention rapide 24h/24 pour volets roulants bloqués ou en panne",
    },
  ];

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-8">
          Pages connexes
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="bg-brand-light border border-brand-border rounded-xl p-5 md:p-6 hover:border-brand-cyan transition-colors group"
            >
              <h3 className="text-brand-blue font-semibold text-base mb-2 group-hover:text-brand-cyan transition-colors">
                {link.label}
              </h3>
              <p className="text-brand-text text-sm leading-relaxed">{link.desc}</p>
              <span className="inline-flex items-center gap-1 text-brand-cyan text-sm font-medium mt-4">
                Découvrir
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}